<template>
  <div class="CCloseBorrow">
    <div>
      <!-- <div class="icon el-icon-circle-check-outline"></div> -->
      <div class="titName">箱门已关闭，盘点结果为：(出库：{{boxTool.loan.length}}个,入库：{{boxTool.back.length}}个)</div>
      <template v-if="project_type == '1'">
        <div class="invenDiv" v-if="noList == false" @click="time = 10">
          <el-table :data="tableData" style="width:100%" :row-class-name="tableRowClassName" height="calc(100vh - 3rem)">
            <!-- <el-table-column label="产品名称" prop="name" min-width="50%"></el-table-column> -->
            <el-table-column label="RFID" prop="rfid" min-width="50%"></el-table-column>
            <el-table-column label="数量" min-width="20%">
              <template slot-scope="scope">
                <span>{{scope.row.number}}个</span>
              </template>
            </el-table-column>
            <el-table-column label="箱格号" prop="locationid" min-width="20%"></el-table-column>
            <el-table-column label="类型" min-width="10%">
              <template slot-scope="scope">
                <template v-if="type == '3'">
                  <span>/</span>
                </template>
                <template v-else>
                  <span v-if="scope.row.type==1">放入</span>
                  <span v-else-if="scope.row.type==2">取走</span>
                  <span v-else>非法</span>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <template v-else>
        <div class="invenDiv" v-if="boxTool.back!='' || boxTool.loan!='' || boxTool.errorRfid" @click="time = 10">
          <el-table :data="tableData" style="width:100%" :row-class-name="tableRowClassName" height="calc(100vh - 3rem)">
            <!-- <el-table-column label="产品名称" prop="name" min-width="50%"></el-table-column> -->
            <el-table-column label="RFID" prop="rfid" min-width="50%"></el-table-column>
            <el-table-column label="数量" min-width="20%">
              <template slot-scope="scope">
                <span>{{scope.row.number}}个</span>
              </template>
            </el-table-column>
            <el-table-column label="箱格号" prop="locationid" min-width="20%"></el-table-column>
            <el-table-column label="类型" min-width="10%">
              <template slot-scope="scope">
                <span v-if="scope.row.type==1">放入</span>
                <span v-else-if="scope.row.type==2">取走</span>
                  <span v-else>非法</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <template v-if="project_type == '1' && noList == true">
        <div class="name">
          您在编号为：<span>{{boxId}}号箱格</span>未
          <template v-if="type == '1'">借用</template>
          <template v-else-if="type == '2'">归还</template>
          <template v-else>入库</template>
          任何物品。
        </div>
      </template>
      <template v-if="boxTool.back == '' && boxTool.loan == '' && !boxTool.errorRfid">
        <template>
        <div class="name">
          您在编号为：<span>{{boxId}}号箱格</span>未
          <template v-if="type == '1'">取走</template>
          <template v-else>放入</template>
          任何物品。
        </div>
        </template>
      </template>
      <div class="btnCont">
        <div class="tips">本页面于{{time}}秒后退出登录</div>
        <div class="btnDiv">
          <el-button @click="backUp">返回</el-button>
          <el-button @click="loginOut">退出登录</el-button>
        </div>
      </div>
    </div>
    <currtime :isShowInfo="isShowInfo"></currtime>
  </div>
</template>

<script>
import currtime from '../../../../../assets/currTime'
import { storage,localUserInfo,conLog } from '../../../../../../static/js/utils/utility.js'
export default {
  name: 'CCloseBorrow',
  data () {
    return {
      boxId:'',
      time:10,
      timeStatus:'',
      boxTool:{
        back:[],
        loan:[],
      },
      type:'',

      project_type:'',

      isShowInfo:false,

      tableData:[],

      noList:true,
    }
  },
  mounted(){
  },
  created(){
    var configStorage = JSON.parse(localStorage.getItem('configStorage'))
    if(configStorage){
      this.project_type = configStorage.unmanShow
    }
    this.boxId = this.$route.query.boxId
    this.type = this.$route.query.type
    if(this.type=='2'){
      this.isShowInfo = false
    }else{
      this.isShowInfo = true
    }
    this.getTools()
  },
  components:{
    currtime,
  },
  methods:{
    //获取工具
    getTools(){
      var that = this;
      this.boxTool = storage.sessionGetItem('boxInventory')
      if(that.boxTool.errorRfid!=''){
        for(var i in that.boxTool.errorRfid){
          var obj ={
            locationid:that.boxId,
            type:'3',
            number:'1',
            name:that.boxTool.errorRfid[i],
          }
          that.tableData.push(obj)
        }
      }
      if(this.project_type == '1'){
        if(that.boxTool.loan!=''){
          for(var i in that.boxTool.loan){
            if(that.boxTool.loan[i].list){
              for(var ii in that.boxTool.loan[i].list){
                that.boxTool.loan[i].list[ii].locationid = that.boxTool.loan[i].locationid
                that.boxTool.loan[i].list[ii].type='2'
                that.tableData.push(that.boxTool.loan[i].list[ii])
              }
            }
          }
          var result11 = that.boxTool.loan.some(function(item) {
            if (item.list) {
                return true;
            }
          })
          if(result11 == true){
            that.noList = false
          }else{
            that.noList = true
          }
        }
        if(that.boxTool.back!=''){
          for(var i in that.boxTool.back){
            if(that.boxTool.back[i].list){
              for(var ii in that.boxTool.back[i].list){
                that.boxTool.back[i].list[ii].locationid = that.boxTool.back[i].locationid
                that.boxTool.back[i].list[ii].type='1'
                that.tableData.push(that.boxTool.back[i].list[ii])
              }
            }
          }
          var result11 = that.boxTool.back.some(function(item) {
            if (item.list) {
                return true;
            }
          })
          if(result11 == true){
            that.noList = false
          }else{
            that.noList = true
          }
        }
        
      }else if(this.project_type == '2'){
        if(that.boxTool.back!=''){
          for(var i in that.boxTool.back){
            that.boxTool.back[i].locationid = that.boxId
            that.boxTool.back[i].type='1'
            that.tableData.push(that.boxTool.back[i])
            // if(that.boxTool.back[i].list){
            //   for(var ii in that.boxTool.back[i].list){
            //     that.boxTool.back[i].list[ii].locationid = that.boxTool.back[i].locationid
            //     that.boxTool.back[i].list[ii].type='1'
            //     that.tableData.push(that.boxTool.back[i].list[ii])
            //   }
            // }
          }
        }
        if(that.boxTool.loan!=''){
          for(var i in that.boxTool.loan){
            that.boxTool.loan[i].locationid = that.boxId
            that.boxTool.loan[i].type='2'
            that.tableData.push(that.boxTool.loan[i])
            // if(that.boxTool.loan[i].list){
            //   for(var ii in that.boxTool.loan[i].list){
            //     that.boxTool.loan[i].list[ii].locationid = that.boxTool.loan[i].locationid
            //     that.boxTool.loan[i].list[ii].type='2'
            //     that.tableData.push(that.boxTool.loan[i].list[ii])
            //   }
            // }
          }
        }
      }
      this.getSecond(this.time)
    },
    tableRowClassName({row, rowIndex}){
      if(this.project_type == '1'){
        if(this.type=='1' && row.type=='1'){
          return 'waring_sp'
        }
        if(this.type=='2' && row.type=='2'){
          return 'waring_sp'
        }
      }else{
        if(this.type=='1' && row.type=='1'){
          return 'waring_sp'
        }
        if(this.type=='3' && row.type=='2'){
          return 'waring_sp'
        }
      }
      if(row.type == '3'){
        return 'waring_sp'
      }
      
    },
    //倒计时
    getSecond(wait){
      conLog('CClosegetSecond',wait)
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        storage.sessionRemoveItem('boxInventory')
        wait = _wait;
        that.loginOut()
      } else {
        that.time=wait
        that.time--;
        that.timeStatus = setTimeout(function() {
          that.getSecond(that.time);
        },1000);
      }
    },
    //返回
    backUp(){
      var that = this
      storage.sessionRemoveItem('boxInventory')
      clearTimeout(this.timeStatus)
      if(this.type == '1'){
        that.$router.push({
          path:'/toolCabinet/CBorrow'
        })
      }else if(this.type == '2'){
        that.$router.push({
          path:'/toolCabinet/CLogin'
        })
      }else{
        that.$router.push({
          path:'/toolCabinet/CAdmin'
        })
      }
    },
    //退出登录
    loginOut(){
      var that = this
      clearTimeout(this.timeStatus)
      localUserInfo.removeItem()
      if(this.project_type == '1'){
        that.$router.push({
          path:'/toolCabinet/CLogin'
        })
      }else if(this.project_type == '2'){
        that.$router.push({
          path:'/unmanned/wrcIndex',
        })
      }
    },
  },
  watch :{

  },
}
</script>

<style lang="less">
.CCloseBorrow{
  height: 100vh;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // text-align: center;
  // background: url('../../../../../../static/images/bg.jpg') center no-repeat;
  // background-size: cover;
  .titName{
    height: 1.6rem;
    line-height: 1.6rem;
    padding: 0 0.2rem;
    font-size: 0.4rem;
  }
  .invenDiv{
    .el-table{
      background: none;
      th,tr{
        background: none;
      }
      td,th{
        color: #fff;
        padding: 0.2rem 0;
        font-size: 0.3rem;
        border-bottom: 0.02rem solid #EBEEF5;
        background: none;
      }
      tr.waring_sp td{
        color: #F56C6C;
      }
      .cell{
        line-height: 1;
        padding: 0 0.2rem;
      }
    }
  }
  .adminTip{
    .name{
      display: inline-block;
      margin: 0.1rem 0;
    }
  }
  .icon{
    color: #4babfe;
    font-size: 2rem;
  }
  
  .name{
    font-size: 0.5rem;
    height: calc( 100vh - 3rem);
    display: flex;
    justify-content: center;
    align-items: center;
    span{color:#fff;}
    &.waring_sp{
      color: #F56C6C;
    }
  }
  .btnCont{
    display: flex;
    align-items: center;
    justify-content:space-between;
    padding: 0 0.2rem;
    height: 1.4rem;
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    left: 0;
    bottom: 0;
  }
  .tips{
    font-size: 0.36rem;
    // color: #e2dfdf;
    color: #F56C6C;
  }
  .btnDiv{
    // margin-top: 1.4rem;
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      // margin: 0 1.2rem;
      margin: 0 0.1rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CToolCabinet/page/CEmployee/CBorrow/CCloseDoor.vue